import type { IngredientRef } from '@familychef/shared';
import { Download, Upload } from 'lucide-react';
import Papa from 'papaparse';

interface IngredientCsvActionsProps {
  data: IngredientRef[];
}

const CSV_HEADERS = [
  'name',
  'category',
  'seasons',
  'months',
  'description',
  'density_g_per_ml',
  'tablespoon_g',
  'cup_g',
];

export function IngredientCsvActions({ data }: IngredientCsvActionsProps) {
  function exportCsv() {
    const rows = data.map((ing) => ({
      name: ing.name,
      category: ing.category,
      seasons: ing.seasons.join(','),
      months: ing.months.join(','),
      description: ing.description ?? '',
      density_g_per_ml: ing.density_g_per_ml ?? '',
      tablespoon_g: ing.tablespoon_g ?? '',
      cup_g: ing.cup_g ?? '',
    }));
    const csv = Papa.unparse({ fields: CSV_HEADERS, data: rows });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ingredients_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  function importCsv(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        // For now, just log — full import would call the API
        console.log('Imported rows:', results.data.length);
        alert(`${results.data.length} ingrédients importés (à sauvegarder via API)`);
      },
    });
    // Reset input
    e.target.value = '';
  }

  return (
    <div className="flex gap-2">
      <label className="flex cursor-pointer items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50">
        <Upload size={15} />
        <span className="hidden md:block">Import</span>
        <span className="md:hidden">CSV</span>
        <input type="file" accept=".csv" className="hidden" onChange={importCsv} />
      </label>
      <button
        onClick={exportCsv}
        className="flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
      >
        <Download size={15} />
        <span className="hidden md:block">Export</span>
        <span className="md:hidden">CSV</span>
      </button>
    </div>
  );
}
